@if (breadcrumbs(); as breadcrumbs) {
  @if (breadcrumbs.length) {
    <pt-breadcrumbs class="bg-white" [breadcrumbs]="breadcrumbs" />
    <div class="border-b border-solid border-slate-300"></div>
  }
}

<div class="layout-padding mx-auto max-w-screen-2xl">
  <div class="flex flex-col gap-4">
    <div class="flex items-center justify-end">
      <button mat-flat-button color="primary" (click)="createReferral()">
        Create Referral <mat-icon>add</mat-icon>
      </button>
    </div>

    <pr-referral-list-filters />

    @if (store.filteredReferrals$ | async; as referrals) {
      <pr-referral-list
        (referralSelected)="navigateToReferral($event)"
        (referralRemoved)="deleteReferral($event)"
        (referralUpdated)="updateReferral($event.referral, $event.changes)"
      />
    }
  </div>
</div>
